/**
 * Where a create starts (#632): the association, home and member it is
 * for, when the page already knows. The create modals show these as
 * property chips — pre-filled from here, or empty for the person to pick.
 *
 * A member narrows the home chip to that member's homes (and the
 * association chip to the associations they own in); a vendor pre-fills a
 * work order's vendor.
 *
 * Pure, so the route rules are unit-testable.
 */
export interface CreateScope {
  hoaId?: string | null;
  homeId?: string | null;
  memberId?: string | null;
  vendorId?: string | null;
}

/**
 * The scope implied by a front-porch URL:
 *   /hoa/:hoaId/…                       → the association
 *   /hoa/:hoaId/home/:homeId/…          → and the home
 *   /hoa/:hoaId/member/:memberId/…      → and the member
 * Anything else (`/violations`, `/home`, a violation's own page) implies
 * nothing, and the modal asks.
 */
export const scopeFromPath = (pathname: string): CreateScope => {
  const m = /^\/hoa\/([^/]+)(?:\/(home|member)\/([^/]+))?/.exec(pathname);
  if (!m) return {};
  const [, hoaId, kind, id] = m;
  return {
    hoaId,
    ...(kind === 'home' ? { homeId: id } : {}),
    ...(kind === 'member' ? { memberId: id } : {}),
  };
};
